// extracted by mini-css-extract-plugin
export default {"wrapper":"suggestion-text-box_wrapper__Fa78C"};